<template>
    <div class="card-box m-b-10 card_color_left icon_integration" :class="{ 'active': isEnabled }">
        <div class="bar-widget">
            <div class="d_table">
                <div class="d_t_cell w_60" :class="{ 'opacity_6': !isAvailable }">
                    <router-link :to="`/integrations/${item.slug}`">
                        <div class="iconbox">
                            <i :class="item.icon"></i>
                        </div>
                    </router-link>
                </div>
                <div class="d_t_cell w_full">
                    <router-link :to="`/integrations/${item.slug}`">
                        <h5 class="m-t-0 m-b-5 d_inline_b" :class="{ 'opacity_6': !isAvailable }">
                            <label class="label label-warning m-r-5 m-b-0 pull-left" v-if="item.beta">Beta</label>
                            <b>{{ $t(`_integrations.name_${item.slug}`) }}</b> <small class="text-primary" v-if="!item.available">({{ $t('coming_soon') }})</small>
                        </h5>
                        <p class="m-b-5 text-muted" :class="{ 'opacity_6': !isAvailable }">{{ $t(`_integrations.description_${item.slug}`) }}</p>
                    </router-link>
                    <router-link :to="{ name: 'company.billing' }" class="label label-danger" v-if="!isAvailable">
                        {{ $t('upgrade_your_account_to_get_access_to') }}
                    </router-link>
                </div>
                <div class="d_t_cell w_120 t_right" :class="{ 'opacity_6': !isAvailable }" v-if="isEnabled">
                    <label class="label label-default">{{ $t('activated') }}</label>
                    <div class="clearfix m-b-10"></div>
                    <router-link :to="`/integrations/${item.slug}`" class="btn btn-white btn-sm"><i class="fa-fw fa fa-gear m-r-5"></i> {{ $t('manage') }}</router-link>
                </div>
                <div class="d_t_cell w_120 t_right" :class="{ 'opacity_6': !isAvailable }" v-else>
                    <router-link :to="`/integrations/${item.slug}`" class="btn btn-white btn-sm" v-if="isAvailable">
                        <i class="fa-fw fa fa-plug"></i> {{ $t('activate') }}
                    </router-link>
                    <a href="javascript:;" class="btn btn-white btn-sm" v-else disabled>
                        <i class="fa-fw fa fa-plug"></i> {{ $t('activate') }}
                    </a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { find, isNil } from 'lodash'
    import { mapGetters } from 'vuex'

    export default {
        name: 'IntegrationItem',
        props: [ 'item', 'enabled' ],
        computed: {
            ...mapGetters({
                'tenant': 'getTenant'
            }),
            isEnabled () {
                if (this.item.slug === 'mail-trap') return !isNil(this.tenant.domain)
                return typeof find(this.enabled, { provider: this.item.module }) !== 'undefined' && this.isAvailable
            },
            isAvailable () {
                if (!this.item.available)
                    return false

                const isPremiumPlan = ['premium_power_sales'].includes(this.tenant.stripePlan)
                return (this.item.available && isPremiumPlan) || this.item.slug === 'ical'
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/modules/integrations/components/Item.vue